import { getAuthTokenAync } from "src/store/common";
import { User, Meta } from "src/store/types";
import * as api from "./api";

interface ApiResponse {
  data: User[];
  meta: Meta;
}

// fetch user list
export const fetchUserList = async (data: {
  page: number;
  limit: number;
  search?: string;
}): Promise<ApiResponse> => {
  const params: any = {
    page: data.page,
    limit: data.limit,
  };

  if (data.search && data.search.trim()) {
    params.search = data.search.trim();
  }

  const token = getAuthTokenAync();
  api.setHeaderAuthorization(token);
  const response: any = await api.get(
    `${process.env.REACT_APP_ADMIN_API_URL}/users`,
    params
  );
  return response;
};

// ban/unban user
export const banUnbanUser = (uid: string) => {
  const token = getAuthTokenAync();
  api.setHeaderAuthorization(token);
  return api.get(`${process.env.REACT_APP_ADMIN_API_URL}/users/${uid}`);
};
